<div *ngIf="dataLoaded" class="card card-custom gutter-b">
    <div class="card-header border-0">
        <div class="card-title">
            <h3 class="card-label m-0">Edit Stage</h3>
        </div>
        <div class="card-toolbar">
            <button type="button" class="btn-back" routerLink="/projects/{{projectId}}/stage/{{stageId}}/view">
                <span class="fa fa-arrow-left"></span>
            </button>
        </div>
    </div>

    <div class="card-body">
        <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                          [customSuccessMessage]="successMsg"></app-form-message>

        <form [formGroup]="editStageForm" (ngSubmit)="submitStageForm()">
            <div class="row">
                <div class="col-12 form-group">
                    <p class="form-label">Stage Name</p>
                    <input class="form-control form-control-lg form-layout"
                           type="text"
                           formControlName="name"
                           [class.is-invalid]="isControlInvalid('name')">
                    <div class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                        This field is required!
                    </div>
                </div>

                <div class="col-12 form-group d-flex justify-content-between align-items-center">
                    <p class="form-label m-0">Stage Color</p>
                    <div ngbDropdown class="d-inline-block">
                        <button [ngClass]="editStageForm.value.color" type="button" class="btn btn-success btn-color" id="colorDropdown" ngbDropdownToggle>
                            <span class="fas fa-fill-drip"></span>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="colorDropdown">
                            <button *ngFor="let color of colorsClasses"
                                    class="dropdown-item btn-color" type="button"
                                    [ngClass]="color"
                                    (click)="editStageForm.controls['color'].setValue(color)">
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-6 form-group">
                    <p class="form-label">Start Date</p>
                    <input class="form-control form-control-lg form-layout"
                           type="date"
                           formControlName="startDate"
                           [class.is-invalid]="isControlInvalid('startDate')">
                    <div class="invalid-feedback" *ngIf="controlHasError('startDateIsBiggerThanEndDate', 'startDate')">
                        Start Date can't be bigger than End Date
                    </div>
                    <div class="invalid-feedback" *ngIf="controlHasError('required', 'startDate')">
                        This field is required!
                    </div>
                </div>

                <div class="col-12 col-sm-6 form-group">
                    <p class="form-label">End Date</p>
                    <input class="form-control form-control-lg form-layout"
                           type="date"
                           formControlName="endDate"
                           [class.is-invalid]="isControlInvalid('endDate')">
                    <div class="invalid-feedback" *ngIf="controlHasError('required', 'endDate')">
                        This field is required!
                    </div>
                </div>

                <div class="col-12 form-group">
                    <p class="form-label">Description</p>
                    <textarea class="form-control form-control-lg form-layout"
                              type="text" rows="4"
                              formControlName="description"></textarea>
                </div>

                <div class="col-12 d-flex justify-content-end">
                    <button type="submit" class="btn-default btn-green">
                        Save
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
